import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchProjectTemplates = ({ accountId, branchId, isWeeklyPlanner = false }) =>
  get(`/accounts/${accountId}/branches/${branchId}/project-templates`, { isWeeklyPlanner });

export const fetchProjectTemplate = ({ accountId, branchId, templateId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/project-templates/${templateId}`);

export const addProjectTemplate = ({ accountId, branchId, data }) =>
  post(`/accounts/${accountId}/branches/${branchId}/project-templates`, data);

export const updateProjectTemplate = ({ accountId, branchId, templateId, data }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/project-templates/${templateId}`, data);

export const deleteProjectTemplate = ({ accountId, branchId, templateId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/project-templates/${templateId}`);
